import { render, staticRenderFns } from "./FormRF12.vue?vue&type=template&id=2aac9755"
import script from "./FormRF12.vue?vue&type=script&lang=js"
export * from "./FormRF12.vue?vue&type=script&lang=js"
import style0 from "./FormRF12.vue?vue&type=style&index=0&id=2aac9755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports